var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleG = function SvgGoogleG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBB00",
    d: "m4.072 11.577-.616 2.3-2.253.049A8.812 8.812 0 0 1 .148 9.73c0-1.468.357-2.853.99-4.071l2.006.367.878 1.994a5.262 5.262 0 0 0-.284 1.71c0 .65.118 1.272.334 1.846Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#518EF8",
    d: "M17.697 8.077a8.858 8.858 0 0 1-.039 3.502 8.85 8.85 0 0 1-3.116 5.055l-2.527-.13-.357-2.231a5.276 5.276 0 0 0 2.27-2.694H9.195V8.077h8.502Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B446",
    d: "M14.543 16.633a8.814 8.814 0 0 1-5.542 1.95 8.85 8.85 0 0 1-7.797-4.658l2.869-2.348a5.263 5.263 0 0 0 7.586 2.696l2.884 2.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F14336",
    d: "m14.65 2.916-2.867 2.348a5.265 5.265 0 0 0-7.76 2.756L1.138 5.66A8.85 8.85 0 0 1 9 .877c2.148 0 4.117.765 5.65 2.038Z"
  })));
};
export default SvgGoogleG;